<template>
  <div class="flex-container">
    <div class="flex-child">
      <h4 class="layoutheader">*Please pick a floor style</h4>
      <div>
        <div role="group" aria-label="Basic radio toggle button group">
          <ul id="radioAssetOptions">
            <li v-for="(item, index) in configOptions" :key="item">
              <input type="radio" :id="index" :value="item" v-model="picked" name="picked" @click="OnClicked"
                required />
              <label :for="index">{{ item }} </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="flex-child">
      <img class="box_img" v-show="picked === 'Boardroom'" src="@/assets/fchq/fchqlayouts/boardroom2.svg" />
      <img class="box_img" v-show="picked === 'Default'" src="@/assets/fchq/fchqlayouts/default.png" />
      <img v-show="picked === 'Hollow Square'" class="box_img" src="@/assets/fchq/fchqlayouts/hallow.png" />
      <img v-show="picked === 'U-shape'" class="box_img" src="@/assets/fchq/fchqlayouts/ushape.png" />
      <img v-show="picked === 'Auditorium'" class="box_img" src="@/assets/fchq/fchqlayouts/auditorium.png" />
      <img v-show="picked === 'Classroom'" class="box_img" src="@/assets/fchq/fchqlayouts/classroom.png" />
      <img v-show="picked === 'Cocktail/Bar'" class="box_img" src="@/assets/fchq/fchqlayouts/banquet.png" />
    </div>
  </div>
</template>
<script>
export default {
  props: ['configuration'],
  data() {
    return {
      picked: 'Default',
      id: '',
      configOptions: [],
    };
  },
  watch: {
    configuration() {
      this.configOptions = this.configuration.configOptions;
    },

    picked() {
      // console.log('picked ', this.picked);
      this.$emit('config-picked', [this.picked]);
    },
  },

  methods: {
    OnClicked(ev) {
      // console.log('this layout', ev.target.id);
      this.id = ev.target.id;
    },
  },
};
</script>
<style scoped>
ul {
  list-style-type: none;
}

.layoutheader {
  margin: 2rem;
}

.flex-container {
  display: flex;
}

.flex-child {
  flex: 1;
  border: 2px solid rgb(255, 255, 255);
}

.flex-child:first-child {
  margin-right: 20px;
}

.box_img {
  margin: 1rem;
  width: 85%;
}

.box img {
  object-fit: cover;
}
</style>
